import React, { useState } from 'react';
import { Typography, Button, ToggleButtonGroup, Snackbar, ToggleButton, Container, Grid, Card, CardContent, CardMedia, Box, TextField } from "@mui/material";
import { motion } from "framer-motion";
// import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

// const sliderSettings = {
//   dots: false,
//   infinite: false,
//   speed: 500,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   nextArrow: <ArrowForwardIos sx={{ color: "white" }} />,
//   prevArrow: <ArrowBackIos sx={{ color: "white" }} />,
//   responsive: [
//     {
//       breakpoint: 960,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// };

const events = [
  {
    id: 1,
    image: 'https://m.media-amazon.com/images/I/71mICEGSRWL.jpg',
    title: 'Karaoke',
    day: 'Mondays',
    time: '7pm',
  },
  {
    id: 2,
    image: 'https://media.istockphoto.com/id/1469754711/vector/trivia-time-neon-sign-geometric-frame-decoration-quiz-show-label-on-brick-wall-vector-stock.jpg?s=612x612&w=0&k=20&c=7D-_PFacHKOD6pGYMaLa0FkR9PdKjXqmb1zZ4tIhEDQ=',
    title: 'Trivia',
    day: 'Tuesdays',
    time: '8pm',
  },
  {
    id: 3,
    image: 'https://www.vaprojectlife.org/wp-content/uploads/2021/06/bingo-image.jpg',
    title: 'Bingo',
    day: 'Wednesdays',
    time: '10pm',
  },
];
const menuItems = {
  favorites: [
    {
      title: "Grilled Salmon",
      description: "Fresh Atlantic salmon served with seasonal vegetables and lemon butter sauce.",
      image: "https://toriavey.com/images/2014/04/MG_5907.jpg"
    },
    {
      title: "B'Crazy Double Decker",
      description: "Our famous double decker served on a brioche bun with our secret sauce.",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9XNCOd0WnLHDxb288Kq4RM8mrER4nQOAgFg&s"
    },
    {
      title: "Buffalo chicken wrap",
      description: "The classic wrap is back! Be sure to get it while its here.",
      image: "https://www.allrecipes.com/thmb/5BWYRjbPBQu7p7J0YInrHkGnVJU=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/AR-188473-Buffalo-Chicken-Wraps-ddmfs-gw-beauty-4x3-adec66cb0d4e46b48ac4f07ee648fec7.jpg"
    },
  ],
  drinks: [
    {
      title: 'Margarita',
      description: 'Comes in strawberry, blueberry, lime, and classic',
      image: "https://www.santospirits.com/wp-content/uploads/2024/01/velvet_kickstand_margarita.jpg",
    },
    {
      title: 'Short Island',
      description: 'A long island compacted into a strong shot glass',
      image: "https://barsandbartending.com/wp-content/uploads/2024/02/how-to-make-a-long-island-iced-tea.webp"
    },
    {
      title: 'Strawberry Mule',
      description: 'Low calories while containing our berry goodness',
      image: "https://entirelyelizabeth.com/wp-content/uploads/2023/08/IMG_1294-2.jpg"
    },
  ],
  appetizers: [
    {
      title: 'Loaded Tots',
      description: 'Homegrown potatoes layered with savory bacon and ranch drizzle',
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR02mVCq3R7NJOamz5qOgxdmgvJThmmxpRF3A&s"
    },
    {
      title: 'Onion Rings',
      description: 'Our spin off the traditional onion ring. Our crazy sauce will knock your socks off',
      image: "https://thebigmansworld.com/wp-content/uploads/2025/01/air-fryer-onion-rings-recipe.jpg"
    },
    {
      title: 'Cheese Sticks',
      description: 'Oldie, but a goodie. Mozzarella straight from Milan',
      image: "https://stressbaking.com/wp-content/uploads/2023/03/mozzarella-sticks-cheese-pull.png"
    },
    {
      title: 'Boneless Wings',
      description: 'Served with a side of ranch',
      image: "https://thebigmansworld.com/wp-content/uploads/2024/11/boneless-chicken-wings-recipe.jpg"
    },
    {
      title: "Burger B' Sliders",
      description: 'Our signature burgers, but little!',
      image: "https://www.southernliving.com/thmb/2r_cxc88nW9gm5k2HM4J8rM4DCs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Cheeseburger_Sliders_015-611e2b1b563f4333b201505afd414157.jpg"
    },

  ],
  burgers: [
    {
      title: 'Classic burger',
      description: "Can't go wrong with a classic",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShm0-V8pKFHqzMPT60b-arEO5ruRGOhxr4oA&s"
    },
    {
      title: "B'Crazy Double Decker",
      description: "Our famous double decker served on a brioche bun with our secret sauce.",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9XNCOd0WnLHDxb288Kq4RM8mrER4nQOAgFg&s"
    },
    {
      title: "Steak Burger",
      description: "Delicious Wagyu imported from Australia.",
      image: "https://www.psseasoning.com/cdn/shop/articles/0Wv1vU-Q.jpg?v=1618429573&width=1600"
    },
    {
      title: "The Sunrise",
      description: "Can't go wrong with an egg on top.",
      image: "https://food.fnr.sndimg.com/content/dam/images/food/fullset/2015/11/2/2/FNK_Hangover-Sausage-Egg-Burger_s4x3.jpg.rend.hgtvcom.1280.960.suffix/1447284805283.webp"
    },
    {
      title: "BBQ Goodness",
      description: "Onion rings combined with BBQ AND our secret sauce .",
      image: "https://www.allrecipes.com/thmb/AEUv2IFTElpnEekzq2QSvz-9zbI=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/4023531-6fd6a7e8b02d47609879f935b9b18310.jpg"
    },
    {
      title: "Black and Blue",
      description: "Blue cheese crumbles combined with our quality beef",
      image: "https://fireandsmokesociety.com/cdn/shop/articles/Burgers-with-Bleu-Cheese-and-Black-and-Tan-Seasoning.jpg?v=1688997578"
    },

  ],
};

const RestaurantExampleHome = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('')

  const [category, setCategory] = useState('favorites')

  const [isSnackOpen, setIsSnackOpen] = useState(true);

  const sendEmail = () => {
    console.log('this is an example and not an actual website, so dont send anything');
  }

  const handleCategoryChange = (event, newCategory) => {
    if (newCategory !== null) setCategory(newCategory);
  }

  return (
    <Box id="restaurant-example-home" sx={{ backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
      <Box
        sx={{
          backgroundImage: 'url(https://media.istockphoto.com/id/1043479218/photo/group-of-cheerful-business-people-having-fun-on-a-lunch.jpg?s=612x612&w=0&k=20&c=LfcYDMMypUxbYyeYCwA6-zB3uRITwqvFLnLZq-dCnAM=)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: 500,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h2"
          component={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          sx={{
            color: 'white',
            backgroundColor: 'rgba(0,0,0,0.5)',
            px: 4,
            py: 2,
            borderRadius: 3,
            textAlign: 'center',
          }}
        >
          Welcome to Burger B Crazy
        </Typography>
      </Box>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Box sx={{ p: 4, backgroundColor: 'white', borderRadius: 3, boxShadow: 3, mb: 6 }}>
          <Typography variant="h4" gutterBottom align="center">Upcoming Events</Typography>
          <Grid container spacing={4}>
            {events.map((event) => (
              <Grid item key={event.id} xs={12} sm={6} md={4}>
                <Card sx={{ bgcolor: "#1f1f1f", color: "#fff" }}>
                  <CardMedia
                    component="img"
                    height="160"
                    image={event.image}
                    alt={event.title}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5">
                      {event.title}
                    </Typography>
                    <Typography>
                      {event.day} | {event.time}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ p: 4, backgroundColor: 'white', borderRadius: 3, boxShadow: 3, mb: 6 }}>
          <Typography variant="h4" gutterBottom align="center">Menu</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <ToggleButtonGroup
              color="primary"
              value={category}
              exclusive
              onChange={handleCategoryChange}
              aria-label="food category"
            >
              <ToggleButton value="favorites">Favorites</ToggleButton>
              <ToggleButton value="appetizers">Appetizers</ToggleButton>
              <ToggleButton value="drinks">Drinks</ToggleButton>
              <ToggleButton value="burgers">Burgers</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Grid container spacing={4}>
            {menuItems[category].map((item, index) => (
              <Grid item key={index} xs={12} sm={6} md={4}>
                <Card component={motion.div} whileHover={{ scale: 1.05 }} sx={{ borderRadius: 2 }}>
                  <CardMedia
                    component="img"
                    height="180"
                    image={item.image}
                    alt={item.title}
                  />
                  <CardContent>
                    <Typography variant="h6" gutterBottom>{item.title}</Typography>
                    <Typography variant="body2" color="text.secondary">{item.description}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ p: 4, backgroundColor: 'white', borderRadius: 3, boxShadow: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>Contact Us</Typography>
          <Card sx={{ p: 3, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  variant="filled"
                  fullWidth
                  required
                  label="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  inputProps={{ style: { color: 'black' } }}
                  InputLabelProps={{ style: { color: 'black' } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  variant="filled"
                  fullWidth
                  required
                  label="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  inputProps={{ style: { color: 'black' } }}
                  InputLabelProps={{ style: { color: 'black' } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="filled"
                  fullWidth
                  required
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  inputProps={{ style: { color: 'black' } }}
                  InputLabelProps={{ style: { color: 'black' } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="filled"
                  fullWidth
                  required
                  label="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  inputProps={{ style: { color: 'black' } }}
                  InputLabelProps={{ style: { color: 'black' } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="filled"
                  fullWidth
                  required
                  label="Description"
                  multiline
                  rows={4}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  inputProps={{ style: { color: 'black' } }}
                  InputLabelProps={{ style: { color: 'black' } }}
                />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <Button variant="contained" size="large" onClick={sendEmail}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Box>

        <Box sx={{ backgroundColor: '#2E3B55', color: 'white', py: 3, mt: 6, borderRadius: 2 }}>
          <Typography variant="body2" align="center">
            © 2025 huhnbp. All rights reserved.
          </Typography>
        </Box>
      </Container>
      <Snackbar
        open={isSnackOpen}
        autoHideDuration={6000}
        onClose={() => { setIsSnackOpen(!isSnackOpen) }}
        message="NOTE: This is an example website and not a restaurant"
      />
    </Box>
  )
}

export default RestaurantExampleHome;
